export const environment = {
  ENV: 'PROD',
  API: 'https://api.virtualevaluator.net'
};



// WEBPACK FOOTER //
// /home/rubylover/Work/new_vin_photo/site/web/src/environments/environment.ts